import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import './LoadingScreenSmall.scss';
import { CSSTransition } from 'react-transition-group';

import wordmark from 'icons/wordmark.svg';
import logo from 'icons/logo-transparent.png';

const LoadingScreenSmall = (props) => {
  const { exit } = props;

  const doExit = exit;
  const onLogout = useLocation().search.indexOf('logout=true') >= 0;
  if (onLogout) return null;
  return (
    <CSSTransition
      unmountOnExit
      in={!doExit}
      exit={doExit}
      timeout={500}
      classNames='fade-load-screen'
      data-testid='loading-screen'
    >
      <div className='loading-screen-small'>
        <div className='loading-screen-small__inner-wrapper'>
          <div className='loading-screen-small__centered-content'>
            <div className='lds-ring-small'>
              <div />
              <div />
              <div />
              <div />
            </div>
          </div>
        </div>
      </div>
    </CSSTransition>
  );
};

LoadingScreenSmall.defaultProps = {};

LoadingScreenSmall.propTypes = {
  exit: PropTypes.bool.isRequired,
};

export default LoadingScreenSmall;
